<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Cash Advance</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Expense</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  class="btn add-btn"
                  @click="openCashRetirement"
                  v-if="
                    !advance.cashRetirement &&
                      advance.status == 1 &&
                      advance.requestBy == currentUser.employee.id
                  "
                  ><i class="fa fa-plus"></i> Open Retirement</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="col-md-12">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="message"
                >
                  <strong>Success!</strong> {{ message }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="col-md-12">
                <div class="accordion" id="accordionExample">
                  <div class="card mb-3">
                    <div class="card-header" id="headingOne">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <button class="btn collapsed">
                          General
                        </button>
                        <span class="collapsed menu-arrow">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <form @submit.prevent="onSubmit">
                          <div class="d-flex justify-content-between mt-1">
                            <div></div>
                            <button
                              class="btn text-primary float-right mr-3"
                              v-if="
                                advance.status == 0 &&
                                  advance.approvedByManager == null &&
                                  advance.requestBy == currentUser.employee.id
                              "
                            >
                              <i class="la la-check"></i> Save
                            </button>
                          </div>
                          <hr class="mt-1" />
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label
                                  >Date
                                  <span class="text-danger">*</span></label
                                >
                                <div class="cal-icon">
                                  <datepicker
                                    v-model="advance.date"
                                    bootstrap-styling
                                    class="form-control datetimepicker"
                                    type="date"
                                    :disabled="
                                      currentUser.employee.id !==
                                        advance.requestBy
                                    "
                                  />
                                  <!-- <input class="form-control datetimepicker" type="text"> -->
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label
                                  >Employee
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  placeholder="Select Employee"
                                  class="form-control"
                                  v-model.trim="advance.requestBy"
                                  :disabled="
                                    currentUser.employee.id !==
                                      advance.requestBy
                                  "
                                >
                                  <option disabled>Select Staff</option>
                                  <option
                                    v-for="member in employees"
                                    :key="member.id"
                                    :value="member.id"
                                  >
                                    {{
                                      member.lastName + " " + member.firstName
                                    }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <label
                                  >Description
                                  <span class="text-danger">*</span></label
                                >
                                <textarea
                                  type="text"
                                  rows="5"
                                  cols="7"
                                  class="form-control"
                                  v-model="advance.description"
                                  :disabled="
                                    advance.approvedByManager ||
                                      currentUser.employee.id !==
                                        advance.requestBy
                                  "
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>
                                  Amount <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="advance.amount"
                                  :disabled="
                                    advance.approvedByManager ||
                                      currentUser.employee.id !==
                                        advance.requestBy
                                  "
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>
                                  Payment Method
                                  <span class="text-danger">*</span>
                                </label>
                                <select
                                  class="form-control"
                                  v-model="advance.paymentOption"
                                  :disabled="
                                    advance.approvedByManager ||
                                      currentUser.employee.id !==
                                        advance.requestBy
                                  "
                                >
                                  <option>Select Bank</option>
                                  <option value="Cash">Cash</option>
                                  <option value="Transfer">Transfer</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="advance.paymentOption == 'Transfer'"
                          >
                            <div class="col-md-3">
                              <div class="form-group">
                                <label>
                                  Bank <span class="text-danger">*</span>
                                </label>
                                <select
                                  class="form-control"
                                  v-model="advance.payeeBankName"
                                  :disabled="
                                    advance.approvedByManager ||
                                      currentUser.employee.id !==
                                        advance.requestBy
                                  "
                                >
                                  <option>Select Bank</option>
                                  <option
                                    v-for="item in banks"
                                    :key="item.lookupValue"
                                    :value="item.lookupDescription"
                                  >
                                    {{ item.lookupDescription }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <label>
                                  Account Number
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="advance.payeeAccountNumber"
                                  :disabled="
                                    advance.approvedByManager ||
                                      currentUser.employee.id !==
                                        advance.requestBy
                                  "
                                />
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <label>
                                  Payee Account Name
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  v-model="advance.payeeAccountName"
                                  type="text"
                                  class="form-control"
                                  :disabled="
                                    advance.approvedByManager &&
                                      currentUser.employee.id !==
                                        advance.requestBy
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-3" v-if="advance.cashRetirement">
                    <div class="card-header" id="headingTwo">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="true"
                        aria-controls="collapseTwo"
                      >
                        <button class="btn collapsed">
                          Cash Retirement
                        </button>
                        <span class="collapsed menu-arrow">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseTwo"
                      class="collapse show"
                      aria-labelledby="headingTwo"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <form @submit.prevent="changeAdvanceStatus">
                          <div class="d-flex justify-content-between mt-1">
                            <a
                              class="btn text-primary float-left"
                              @click="openDialogStatus"
                              v-if="
                                advance.cashRetirement.status == 0 &&
                                  advance.cashRetirement.approvedBy == null &&
                                  isManager &&
                                  advance.cashRetirement.retiredBy !=
                                    currentUser.employee.id
                              "
                              ><i class="fa fa-check"></i> Approve / Reject</a
                            >
                            <a
                              class="btn text-primary float-left"
                              @click="onSubmitForApproval"
                              v-if="
                                advance.cashRetirement.status == 7 &&
                                  advance.cashRetirement.retiredBy ==
                                    currentUser.employee.id
                              "
                              ><i class="fa fa-ticket"></i> Submit for
                              Approval</a
                            >
                            <button
                              class="btn text-primary float-right mr-3"
                              v-if="
                                advance.cashRetirement.status == 7 &&
                                  advance.cashRetirement.retiredBy ==
                                    currentUser.employee.id
                              "
                            >
                              <i class="la la-check"></i> Save
                            </button>
                          </div>
                          <hr class="mt-1" />
                          <div class="row">
                            <div class="col-md-5">
                              <div class="form-group">
                                <label
                                  >Date
                                  <span class="text-danger">*</span></label
                                >
                                <div class="cal-icon">
                                  <datepicker
                                    v-model="advance.cashRetirement.date"
                                    bootstrap-styling
                                    class="form-control datetimepicker"
                                    type="date"
                                    disabled
                                  />
                                  <!-- <input class="form-control datetimepicker" type="text"> -->
                                </div>
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div class="form-group">
                                <label
                                  >Retired By
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  placeholder="Select Employee"
                                  class="form-control"
                                  v-model.trim="
                                    advance.cashRetirement.retiredBy
                                  "
                                  disabled
                                >
                                  <option disabled>Select Staff</option>
                                  <option
                                    v-for="member in employees"
                                    :key="member.id"
                                    :value="member.id"
                                  >
                                    {{
                                      member.lastName + " " + member.firstName
                                    }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-10">
                              <div class="form-group">
                                <label
                                  >Description
                                  <span class="text-danger">*</span></label
                                >
                                <textarea
                                  type="text"
                                  rows="5"
                                  cols="7"
                                  class="form-control"
                                  v-model="
                                    advance.cashRetirement.postingDescription
                                  "
                                  :disabled="advance.cashRetirement.status != 1"
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-5">
                              <div class="form-group">
                                <label>
                                  Retired Amount
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="advance.cashRetirement.retiredAmount"
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div class="form-group">
                                <label>
                                  Reimbursement Amount
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="
                                    advance.cashRetirement.reimburseAmount
                                  "
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-3" v-if="advance.cashRetirement">
                    <div class="card-header" id="headingThree">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        <button class="btn collapsed">
                          Cash Retirement Lines ({{
                            advance.cashRetirement.cashRetirementLines &&
                              advance.cashRetirement.cashRetirementLines.length
                          }})
                        </button>
                        <span
                          class="collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseThree"
                      class="collapse"
                      aria-labelledby="headingThree"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row">
                          <a
                            @click="openDialogMeasurement"
                            class="btn text-primary ml-3"
                            v-if="
                              advance.cashRetirement &&
                                advance.status == 1 &&
                                advance.requestBy == currentUser.employee.id
                            "
                          >
                            <i class="la la-plus"></i> Add
                          </a>
                        </div>
                        <hr />

                        <!-- Add Measurement Modal -->
                        <v-dialog v-model="dialogMeasurement" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Add Cash Retirement Line
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeMeasurement"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onSubmitMeasurement">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Transaction Date
                                            <span class="text-danger">*</span>
                                          </label>
                                          <div class="cal-icon">
                                            <datepicker
                                              v-model="transactionDate"
                                              bootstrap-styling
                                              class="form-control datetimepicker"
                                              type="date"
                                            />
                                            <!-- <input class="form-control datetimepicker" type="text"> -->
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Amount
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="amount"
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                              <div class="form-group">
                                <label
                                  >Expense Type
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  class="form-control"
                                  v-model="glAccount"
                                >
                                  <option>Select Type</option>
                                  <option
                                    v-for="item in expenseTypes"
                                    :key="item.id"
                                    :value="item.glAccount"
                                    >{{ item.name }}</option
                                  >
                                </select>
                              </div>
                            </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Description
                                            <span class="text-danger">*</span>
                                          </label>
                                          <textarea
                                            type="text"
                                            rows="5"
                                            cols="7"
                                            class="form-control"
                                            v-model="description"
                                          >
                                          </textarea>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Quantity
                                            <!-- <span class="text-danger">*</span> -->
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              cashRetirementLine.quantity
                                            "
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Unit Cost
                                            <!-- <span class="text-danger">*</span> -->
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              cashRetirementLine.unitCost
                                            "
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <!-- <div class="row">
                                      <div class="col-12">
                                        <p>Kindly provide the link to the retirement evidence</p>
                                      </div>
                                      <div class="col-sm-6">
                                        <div class="form-group">
                                          <label>Name</label>
                                          <div class="custom-file">
                                            <input
                                              type="text"
                                              name="linkName"
                                              class="form-control"
                                              v-model="linkName"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-sm-6">
                                        <div class="form-group">
                                          <label>Link</label>
                                          <div class="custom-file">
                                            <input
                                              type="text"
                                              name="link"
                                              class="form-control"
                                              v-model="link"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div> -->
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /Add Measurement Modal -->

                        <!-- edit Measurement Modal -->
                        <v-dialog
                          v-model="dialogEditMeasurement"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Edit Cash Retirement Line
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeEditMeasurement"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onEditMeasurement">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Transaction Date
                                            <span class="text-danger">*</span>
                                          </label>
                                          <div class="cal-icon">
                                            <datepicker
                                              v-model="
                                                cashRetirementLine.transactionDate
                                              "
                                              bootstrap-styling
                                              class="form-control datetimepicker"
                                              type="date"
                                            />
                                            <!-- <input class="form-control datetimepicker" type="text"> -->
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Amount
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="cashRetirementLine.amount"
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                              <div class="form-group">
                                <label
                                  >Expense Type
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  class="form-control"
                                  v-model="cashRetirementLine.glAccount"
                                >
                                  <option>Select Type</option>
                                  <option
                                    v-for="item in expenseTypes"
                                    :key="item.id"
                                    :value="item.glAccount"
                                    >{{ item.name }}</option
                                  >
                                </select>
                              </div>
                            </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Description
                                            <span class="text-danger">*</span>
                                          </label>
                                          <textarea
                                            type="text"
                                            rows="5"
                                            cols="7"
                                            class="form-control"
                                            v-model="
                                              cashRetirementLine.description
                                            "
                                          >
                                          </textarea>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Quantity
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              cashRetirementLine.quantity
                                            "
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Unit Cost
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              cashRetirementLine.unitCost
                                            "
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /edit Measurement Modal -->

                        <v-dialog
                          v-model="dialogDeleteMeasurement"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="form-header">
                                <h3>Delete</h3>
                                <p>Are you sure want to delete this?</p>
                              </div>
                              <div class="modal-btn delete-action">
                                <div class="row">
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary continue-btn"
                                      @click="onDeleteMeasurement"
                                      >Delete</a
                                    >
                                  </div>
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary cancel-btn"
                                      @click="closeDeleteMeasurement"
                                      >Cancel</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>

                        <!----Datatable-->
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <v-data-table
                                :headers="headersM"
                                :items="
                                  advance.cashRetirement.cashRetirementLines
                                "
                                sort-by=""
                                class="elevation-1"
                              >
                                <template v-slot:[`item.actions`]="{ item }">
                                  <div
                                    class="dropdown dropdown-action"
                                    v-if="
                                      advance.cashRetirement &&
                                        advance.status == 1 &&
                                        advance.requestBy ==
                                          currentUser.employee.id
                                    "
                                  >
                                    <a
                                      href="#"
                                      class="action-icon dropdown-toggle"
                                      data-toggle="dropdown"
                                      v-if="advance.cashRetirement.status != 1"
                                      aria-expanded="false"
                                      ><i class="material-icons"
                                        >more_vert</i
                                      ></a
                                    >
                                    <div
                                      class="dropdown-menu dropdown-menu-right"
                                    >
                                      <a
                                        class="dropdown-item"
                                        @click="openDialogEditMeasurement(item)"
                                        ><i class="fa fa-pencil m-r-5"></i>
                                        Edit</a
                                      >
                                      <a
                                        class="dropdown-item"
                                        @click="openDeleteMeasurement(item)"
                                        ><i class="fa fa-trash-o m-r-5"></i>
                                        Delete</a
                                      >
                                    </div>
                                  </div>
                                </template>
                              </v-data-table>
                            </div>
                          </div>
                        </div>
                        <!---/Datatable-->
                      </div>
                    </div>
                  </div>
                  <div class="card mb-3" v-if="advance.cashRetirement">
                    <div class="card-header" id="headingFour">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        <button class="btn collapsed">
                          Cash Retirement Links ({{
                            advance.cashRetirement.cashRetirementLinks &&
                              advance.cashRetirement.cashRetirementLinks.length
                          }})
                        </button>
                        <span
                          class="collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseFour"
                      class="collapse"
                      aria-labelledby="headingFour"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row">
                          <a
                            @click="openLinkDialog"
                            class="btn text-primary ml-3"
                            v-if="
                              advance.cashRetirement &&
                                advance.status == 1 &&
                                advance.requestBy == currentUser.employee.id
                            "
                          >
                            <i class="la la-plus"></i> Add
                          </a>
                        </div>
                        <hr />

                        <!-- Add Measurement Modal -->
                        <v-dialog v-model="linkDialog" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Add Cash Retirement Link
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeLinkDialog"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="addRetirementLink">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <p>Kindly provide the link to the retirement evidence</p>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Name
                                            <!-- <span class="text-danger">*</span> -->
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            v-model="
                                              linkName
                                            "
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Link URL
                                            <!-- <span class="text-danger">*</span> -->
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            v-model="
                                              link
                                            "
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button :disabled="loading" class="btn btn-primary submit-btn">
                                    {{ !loading ? 'Submit': 'Please wait...' }}
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /Add Measurement Modal -->

                        <!-- edit Measurement Modal -->
                        <v-dialog
                          v-model="linkEdit"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Edit Cash Retirement Link
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeEditLink"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="updateRetirementLink">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="form-group">
                                      <label>
                                        Name
                                        <!-- <span class="text-danger">*</span> -->
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        v-model="
                                          currentLink.name
                                        "
                                      />
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div class="form-group">
                                      <label>
                                        Link URL
                                        <!-- <span class="text-danger">*</span> -->
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        v-model="
                                          currentLink.link
                                        "
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button :disabled="loading" class="btn btn-primary submit-btn">
                                    {{ !loading ? 'Submit': 'Please wait...' }}
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /edit Measurement Modal -->

                        <v-dialog
                          v-model="linkDelete"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="form-header">
                                <h3>Delete</h3>
                                <p>Are you sure want to delete this?</p>
                              </div>
                              <div class="modal-btn delete-action">
                                <div class="row">
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary continue-btn"
                                      @click="deleteRetirementLink"
                                      :disabled="loading"
                                      >{{ !loading ? 'Delete' : 'Please wait...' }}</a
                                    >
                                  </div>
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary cancel-btn"
                                      @click="closeDeleteLink"
                                      >Cancel</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>

                        <!----Datatable-->
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <v-data-table
                                :headers="headersL"
                                :items="
                                  advance.cashRetirement.cashRetirementLinks
                                "
                                sort-by=""
                                class="elevation-1"
                              >
                                <template v-slot:[`item.name`]="{ item }">
                                  <a :href="item.link" target="_blank" class="text-primary">
                                    {{ item.name }}
                                  </a>
                                </template>
                                <template v-slot:[`item.actions`]="{ item }">
                                  <div
                                    class="dropdown dropdown-action"
                                    v-if="
                                      advance.cashRetirement &&
                                        advance.status == 1 &&
                                        advance.requestBy ==
                                          currentUser.employee.id
                                    "
                                  >
                                    <a
                                      href="#"
                                      class="action-icon dropdown-toggle"
                                      data-toggle="dropdown"
                                      v-if="advance.cashRetirement.status != 1"
                                      aria-expanded="false"
                                      ><i class="material-icons"
                                        >more_vert</i
                                      ></a
                                    >
                                    <div
                                      class="dropdown-menu dropdown-menu-right"
                                    >
                                      <a
                                        class="dropdown-item"
                                        @click="openEditLink(item)"
                                        ><i class="fa fa-pencil m-r-5"></i>
                                        Edit</a
                                      >
                                      <a
                                        class="dropdown-item"
                                        @click="openDeleteLink(item)"
                                        ><i class="fa fa-trash-o m-r-5"></i>
                                        Delete</a
                                      >
                                    </div>
                                  </div>
                                </template>
                              </v-data-table>
                            </div>
                          </div>
                        </div>
                        <!---/Datatable-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <!-- Approve Leave Modal -->
          <v-dialog v-model="dialogStatus" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Cash Advance Approve</h3>
                  <p>Are you sure want to approve for this cash advance?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="changeAdvanceStatus(1)"
                        class="btn btn-primary continue-btn"
                        >Approve</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        @click="changeAdvanceStatus(2)"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                        >Decline</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Approve Leave Modal -->
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { performanceService } from "@/services/performanceService";
import { employeeService } from "@/services/employeeService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
import { required, sameAs } from "vuelidate/lib/validators";
import vueDynamicForms from "vuejs-dynamic-forms";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker,
    vueDynamicForms
  },
  data() {
    return {
      transactionDate: "",
      amount: "",
      description: "",
      glAccount: "",
      advanceId: this.$route.params.id,
      dialogMeasurement: false,
      dialogStatus: false,
      dialogEditMeasurement: false,
      dialogDeleteMeasurement: false,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      headersM: [
        {
          text: "Description",
          align: "start",
          value: "description"
        },
        { text: "Trans. Date", value: "transactionDate" },
        { text: "Quantity", value: "quantity" },
        { text: "Unit Cost", value: "unitCost" },
        { text: "Total Amount", value: "amount" },
        { text: "", value: "actions", sortable: false }
      ],
      headersL: [
        { text: 'Name', value: 'name' },
        { text: "", value: "actions", sortable: false }
      ],
      banks: [],
      employees: [],
      isManager: false,
      advance: {
        date: new Date(),
        requestBy: authenticationService.currentUserValue
          ? authenticationService.currentUserValue.employee.id
          : 0,
        description: "",
        paymentOption: "",
        payeeAccountName: "",
        payeeBankName: "",
        payeeAccountNumber: "",
        amount: 0,
        status: 0,
        cashRetirement: null
      },
      cashRetirementLine: {},
      message: "",
      error: "",
      file: null,
      fileName: "",
      linkName: "",
      link: "",
      linkDialog: false,
      currentLink: {},
      linkEdit: false,
      linkDelete: false,
      loading: false
    }
  },
  methods: {
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },

    openLinkDialog () {
      this.linkDialog = true
    },
    closeLinkDialog () {
      this.linkDialog = false
    },
    openEditLink (item) {
      this.linkEdit = true
      this.currentLink = item
    },
    closeEditLink () {
      this.currentLink = {}
      this.linkEdit = false
    },
    openDeleteLink (item) {
      this.linkDelete = true
      this.currentLink = item
      console.log("item", item.id)
    },
    closeDeleteLink () {
      this.currentLink = {}
      this.linkDelete = false
    },

    importCashRetirement() {
      employeeService.imporyee(this.company.id, this.file).then(
        response => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getEmployees(unit.id).then(model => {
            (this.employees = model), (this.filterEmployees = model);
            //this.message = '';
            this.dialogImport = false;
          });
        },
        error => {
          this.error = error;
        }
      );
    },
    isEmployeeManager() {
      employeeService.isEmployeeManager().then(model => {
        this.isManager = model;
      });
    },
    getBanks() {
      organizationService.getBanks().then(o => (this.banks = o));
    },
    getEmployees() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployees(unit.id).then(
        model => {
          this.employees = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getTypes() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getExpenseType(companyId).then(
        model => {
          this.expenseTypes = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getCashAdvance() {
      employeeService.getCashAdvanceById(this.advanceId).then(
        model => {
          console.log(model);
          this.advance = model;
        },
        error => {
          error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;

      this.loading = true;

      if (
        this.advance.paymentOption == "Transfer" &&
        this.advance.payeeAccountName == ""
      ) {
        this.error = "Enter complete bank details !";
      } else {
        if (!this.advanceId) {
          this.advance.cashRetirement = null;
          employeeService.addCashAdvance(this.advance).then(
            id => {
              this.message = "Cash advance added successfully";
              this.$router.push("/cash-advance-employee");
            },
            error => {
              this.error = error;
              this.loading = false;
            }
          );
        } else {
          employeeService.updateCashAdvance(this.advance).then(
            id => {
              this.message = "Cash advance updated successfully";
              this.getCashAdvance();
            },
            error => {
              this.error = error;
              this.loading = false;
            }
          );
        }
      }
    },
    changeAdvanceStatus(status) {
      this.submitted = true;
      this.advance.cashRetirement.status = status;
      if (status == 1) {
        this.advance.cashRetirement.approvedBy =
          this.currentUser.employee.firstName +
          " " +
          this.currentUser.employee.lastName;
        this.advance.cashRetirement.approvedDate = new Date();
      }
      this.loading = true;
      employeeService.updateCashRetirement(this.advance.cashRetirement).then(
        id => {
          employeeService.getCashAdvanceById(this.advanceId).then(model => {
            console.log(model);
            this.advance = model;
            this.closeStatus();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    openCashRetirement() {
      var req = {
        cashAdvanceId: this.advanceId,
        date: new Date(),
        retiredBy: this.currentUser.employee.id,
        postingDescription: "Retirement for cash advance"
      };
      employeeService.addCashRetirement(req).then(
        model => {
          this.getCashAdvance();
        },
        error => {
          this.error = error;
        }
      );
    },
    onSubmitCashRetirement() {
      employeeService.updateCashRetirement(this.advance.cashRetirement).then(
        model => {
          this.getCashAdvance();
        },
        error => {
          this.error = error;
        }
      );
    },
    onSubmitForApproval() {
      this.advance.cashRetirement.status = 0;
      employeeService.updateCashRetirement(this.advance.cashRetirement).then(
        model => {
          this.getCashAdvance();
        },
        error => {
          this.error = error;
        }
      );
    },
    addRetirementLink() {
      this.loading = true
      var req = {
        cashRetirementId: this.advance.cashRetirement.id,
        name: this.linkName,
        link: this.link
      }
      employeeService.addCashRetirementLink(req).then(
        model => {
          console.log(model)
          this.loading = false
          alert('Cash Retirement link added')
          this.closeLinkDialog()
        },
        error => {
          console.log(error)
          alert(err)
          this.loading = false
        }
      )
    },
    updateRetirementLink () {
      this.loading = true
      employeeService.updateCashRetirementLink(this.currentLink).then(
        res => {
          console.log(res)
          alert("Retirement Link updated successfully")
          this.getCashAdvance();
          this.loading = false
          this.closeEditLink()
        }, 
        err => {
          console.log(err)
          alert(err)
          this.loading = false
        }
      )
    },
    deleteRetirementLink () {
      this.loading = true
      employeeService.removeCashRetirementLink(this.currentLink.id).then(
        res => {
          console.log(res)
          alert("Retirement link deleted")
          this.getCashAdvance()
          this.closeDeleteLink()
          this.loading = false
        },
        err => {
          console.log(err)
          alert(err)
          this.loading = false
        }
      )
    },
    onSubmitMeasurement() {
      this.cashRetirementLine.transactionDate = this.transactionDate;
      this.cashRetirementLine.amount = this.amount;
      this.cashRetirementLine.description = this.description;
      this.cashRetirementLine.glAccount = this.glAccount;
      if (this.description == "") {
        return (this.error = "Enter Cash Retirement field");
      }
      this.cashRetirementLine.cashRetirementId = this.advance.cashRetirement.id;
      console.log(this.cashRetirementLine);
      // if (this.link) {
      //   employeeService.addCashRetirementLine(this.cashRetirementLine).then(
      //     model => {
      //       this.addRetirementLink();
      //       this.closeMeasurement();
      //       this.cashRetirementLine = {};
      //       this.getCashAdvance();
      //     },
      //     error => {
      //       this.error = error;
      //     }
      //   );
      // }
      employeeService.addCashRetirementLine(this.cashRetirementLine).then(
        model => {
          this.closeMeasurement();
          this.cashRetirementLine = {};
          this.getCashAdvance();
        },
        error => {
          this.error = error;
        }
      );
    },
    onEditMeasurement() {
      employeeService.updateCashRetirementLine(this.cashRetirementLine).then(
        model => {
          this.closeEditMeasurement();
          this.cashRetirementLine = {};
          this.getCashAdvance();
        },
        error => {
          this.error = error;
        }
      );
    },
    onDeleteMeasurement() {
      employeeService
        .removeCashRetirementLine(this.cashRetirementLine.id)
        .then(model => {
          this.getCashAdvance();
          this.cashRetirementLine = {};
          this.closeDeleteMeasurement();
        });
    },
    openDialogStatus() {
      this.dialogStatus = true;
    },
    closeDeleteMeasurement() {
      this.dialogDeleteMeasurement = false;
    },
    closeMeasurement() {
      this.dialogMeasurement = false;
    },
    closeStatus() {
      this.dialogStatus = false;
      this.clearModel();
    },
    closeEditMeasurement() {
      this.dialogEditMeasurement = false;
    },
    openDialogMeasurement() {
      this.message = "";
      this.error = "";
      this.dialogMeasurement = true;
    },
    openDialogEditMeasurement(item) {
      this.message = "";
      this.error = "";
      console.log(`item`, item);
      this.cashRetirementLine = item;
      this.dialogEditMeasurement = true;
    },
    openDeleteMeasurement(item) {
      this.cashRetirementLine = item;
      this.dialogDeleteMeasurement = true;
    }
  },
  mounted() {
    this.isEmployeeManager();
    this.getEmployees();
    this.getBanks();
    this.getCashAdvance();
    this.getTypes()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/expenses/CashAdvance/detail2.vue